<template>
    <b-container class="p-0 h-100">
	   <component :is="Parameter.Type + 'Item'" :parameter="Parameter" :IsEditor="IsEditor" @change-parameter="changeParameter" @child-event="listeners" />
    </b-container>
</template>

<script lang="ts">
    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import Parameter from './Parameter';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "./locales/ParametersItems.json";
    import ReportParameters from './ReportParameters'
    import ComboBoxItem from './Items/ComboBoxItem.vue';
    import CheckBoxItem from './Items/CheckBoxItem.vue';
    import DateFieldItem from './Items/DateFieldItem.vue';
    import GridPanelItem from './Items/GridPanelItem.vue';
    import NumberItem from './Items/NumberItem.vue';
    import RadioGroupItem from './Items/RadioGroupItem.vue';
    import SpinnerItem from './Items/SpinnerItem.vue';
    import GhostItem from './Items/GhostItem.vue';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales },
        components: {
            ComboBoxItem,
            CheckBoxItem,
            DateFieldItem,
            GridPanelItem,
            NumberItem,
            RadioGroupItem,
            SpinnerItem,
            GhostItem
        }
    })
	export default class ParametersItems extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: Parameter;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        @Prop()
        public ReportParameters!: ReportParameters;

        private changeParameter(parameter: Parameter){
            this.$emit('change-parameter', parameter);
        }
        
        private listeners(event){
            if(this.Parameter.Listeners != null && this.Parameter.Listeners.length > 0){
                // Pour chaque Listeners
                this.Parameter.Listeners.forEach(listener => {
                    switch(Object(listener).Key){
                        case "Listener":
                            this.listener(Object(listener).Value);
                            break;
                        case "Change":
                            if (event == "updated")
                                this.listener(Object(listener).Value);
                                //this.change(listener.Value);
                            break;
                        case "SetPeriod":
                            if (!isNaN(Number(this.Parameter.Selected)))
                                this.setPeriod(Object(listener).Value, Number(this.Parameter.Selected));
                            break;
                        case "SetValue":
                            if (!isNaN(Number(this.Parameter.Selected)))
                                this.setValue(Object(listener).Value, Number(this.Parameter.Selected));
                            break;
                        default:
                            break;
                    }
                })
            }
        }

        // Si le Listener est de Type Listener
        private listener(listener: string){
             // Split Listener en deux parti
             let listenerSplit: string[] = listener.split(" = ");

             if(listenerSplit.length == 2){
                this.ReportParameters.FieldSets.forEach(field => {
                    if(field != undefined){
                        field.Parameters.forEach(param => {
                            // Remplacer la parti de droite
                            if(listenerSplit[1] !== undefined && listenerSplit[1].includes(param.Name)){
                                listenerSplit[1] = listenerSplit[1].replaceAll(param.Name, param.Selected)
                            }
                        });
                    }
                })

                if(this.ReportParameters.DictionaryParameters != null){
                    Object.keys(this.ReportParameters.DictionaryParameters).forEach(key => {
                    if(listenerSplit[1].includes(key)){
                        listenerSplit[1] = listenerSplit[1].replaceAll(key, this.ReportParameters.DictionaryParameters[key])
                    }
                })

                Object.keys(this.ReportParameters.DictionaryParameters).forEach(key => {
                    if(key === listenerSplit[0]){
                        this.ReportParameters.DictionaryParameters[key] = eval(listenerSplit[1]);
                    }
                })
                }

                this.ReportParameters.FieldSets.forEach(FieldSet => {
                    if(FieldSet != undefined){
                        FieldSet.Parameters.forEach(parameter => {
                            if(parameter.Name === listenerSplit[0]){
                                parameter.Selected = eval(listenerSplit[1]);
                            }
                        });
                    }
                })
             }
        }

        private setPeriod(period: string, selected: Number) {
            let paramName: string[] = period.split(".");

            if (paramName.length == 2) {
                this.ReportParameters.FieldSets.forEach(FieldSet => {
                    if (FieldSet != undefined) {
                        FieldSet.Parameters.forEach(parameter => {
                            // Si la partie de gauche correspond à ce paramètre
                            if (parameter.Name === paramName[0]) {
                                parameter[paramName[1]] = (this.Parameter.Option as any).find(u => u.Key == selected).Value as any;
                            }
                        });
                    }
                })
            }
        }

        private setValue(value: string, selected: Number) {
            let split: string[] = value.split(" = ");

            if (split.length == 2) {
                let paramName : string[] = split[1].split(".");
                this.ReportParameters.FieldSets.forEach(FieldSet => {
                    if (FieldSet != undefined) {
                        FieldSet.Parameters.forEach(parameter => {
                            if (parameter.Name === split[0]) {
                                parameter.Selected = (FieldSet.Parameters.find(u => u.Name == paramName[0])[paramName[1]] as any)?.find(u => u.Key == selected)?.Value as any;
                            }
                        });
                    }
                })
            }
        }

        mounted() {
            this.listeners("mounted");
        }

        updated(){
            this.listeners("updated");
        }
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>